<template>
  <SbEmptyState
    :icon-name="iconName"
    :label="label"
    :description="description"
  >
    <!--
      @slot slot to show empty state text
    -->
    <slot />
  </SbEmptyState>
</template>
<script>
import SbEmptyState from '@src/components/Table/components/SbEmptyState.vue';

export default {
  name: 'SbTableEmptyState',
  components: { SbEmptyState },
  props: {
    /**
    * The icon for the empty state
    */
    iconName: [String], //eslint-disable-line
    /**
    * The label for the empty state
    */
    label: [String], //eslint-disable-line
    /**
    * The description for the empty state
    */
    description: [String] //eslint-disable-line
  },
};
</script>
